import React, { Component } from 'react'
import PropTypes from 'prop-types'
import throttle from 'lodash/throttle'

import UserOutOfOfficeBlock from './UserOutOfOfficeBlock'
import UserYesterdayActivity from './UserYesterdayActivity'
import UserActivityBlock from './UserActivityBlock'
import UserBoard from './UserBoard'
import UserProTrackStartBlock from './UserProTrackStartBlock'
import UserCongratulationsPopup from './UserCongratulationsPopup'
import HasIrregularWorkWeek from './HasIrregularWorkWeek'
import UserProTrackSelectNew from './UserProTrackSelectNew'
import UserProtrackRating from './UserProtrackRating'
import OnboardingFirstActivityModal from 'app/domains/routes/OnBoarding/OnBoardingFirstActivityModal'
import ConfirmOrCancel from 'app/components/Modals/ConfirmOrCancel'

class Dashboard extends Component {
  static propTypes = {
    showModal: PropTypes.func.isRequired,
    getIdentityProgress: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    scrollBodyTo: PropTypes.func.isRequired,
    isShouldShowCongratulation: PropTypes.bool,
    isShouldShowProTrackRatingBlock: PropTypes.bool.isRequired,
    isStageIsSelection: PropTypes.bool.isRequired,
    isShowConfirmationModalForStopProTrack: PropTypes.bool.isRequired,
    isShowConfirmationModalForDifferentProTrack: PropTypes.bool.isRequired,
    isShowConfirmationModalForCommitPreviousActivity: PropTypes.bool.isRequired,
    isUserCanCompletePreviousActivity: PropTypes.bool.isRequired,
    isFirstLogin: PropTypes.bool,
    isYesterdayUserActivity: PropTypes.bool,
    isProTrackStopped: PropTypes.bool,
  }

  timer
  visible

  componentDidMount() {
    const {
      t,
      getIdentityProgress,
      getProfile,
      scrollBodyTo,
      showModal,
      isShowConfirmationModalForSwitchProTrack,
      queries,
      activeProTrackName,
      onRequestClose,
      onConfirm,
      isLoginFlowFinished,
      isShowConfirmationModalForStopProTrack,
      onConfirmStopProTrack,
      onRequestCloseStopProTrack,
      onRequestCloseDifferentProTrack,
      onConfirmStopProTrackAndSelectNewProTrack,
      isShowConfirmationModalForDifferentProTrack,
      isShowConfirmationModalForCommitPreviousActivity,
      onConfirmCommitPreviousActivity,
      onRequestCloseCommitPreviousActivity,
      isUserCanCompletePreviousActivity,
      isUserCanCommit,
      committedToTodayActivity,
      isUserEverTakeProTrack,
      redirectToOnboardingLanding,
    } = this.props
    this.visible = throttle(function () {
      if (!document.hidden) {
        getIdentityProgress()
      }
      if (!isUserEverTakeProTrack) {
        redirectToOnboardingLanding()
      }
    }, 5000)
    getProfile()
    scrollBodyTo(0)
    this.showCongratulations(this.props)
    document.addEventListener('visibilitychange', this.visible)
    if (isLoginFlowFinished && isShowConfirmationModalForSwitchProTrack) {
      showModal(ConfirmOrCancel, {
        title: t('user:Switch your ProTrack'),
        text: t('user:Please confirm you would like to switch from', {
          activeProTrackName,
          newProTrackName: queries.get('proTrackName'),
        }),
        size: 'xxs',
        cancelBtn: t('No'),
        confirmBtn: t('Yes'),
        handleSubmit: onConfirm,
        onRequestClose,
      })
    }
    if (isLoginFlowFinished && isShowConfirmationModalForStopProTrack) {
      showModal(ConfirmOrCancel, {
        title: t('user:Please confirm you would like to pause ProHabits'),
        size: 'sm',
        outBtn: t('user:Take a break or go on vacation/out of office'),
        pauseBtn: t('user:Stop ProHabits indefinitely'),
        cancelBtn: t('Cancel'),
        confirmBtn: t('Confirm'),
        handleSubmit: onConfirmStopProTrack,
        onRequestClose: onRequestCloseStopProTrack,
        isShowPauseOutOfOfficeButtons: isShowConfirmationModalForStopProTrack,
        important: true,
      })
    }
    if (isLoginFlowFinished && isShowConfirmationModalForDifferentProTrack) {
      showModal(ConfirmOrCancel, {
        title: t(`user:Are you sure you want to switch from`, { activeProTrackName }),
        text: committedToTodayActivity
          ? t(
              "user:If you switch, you won't be able to complete today's action. Instead, you will start your new track and will be asked to commit to a new action"
            )
          : '',
        size: 'sm',
        cancelBtn: t('Cancel'),
        confirmBtn: t('Switch ProTrack'),
        handleSubmit: onConfirmStopProTrackAndSelectNewProTrack,
        onRequestClose: onRequestCloseDifferentProTrack,
      })
    }
    if (
      isLoginFlowFinished &&
      isShowConfirmationModalForCommitPreviousActivity &&
      isUserCanCompletePreviousActivity &&
      isUserCanCommit
    ) {
      showModal(ConfirmOrCancel, {
        confirmBtn: t('user:I Did It'),
        title: t('user:Did you complete your previous MicroAction?'),
        handleSubmit: onConfirmCommitPreviousActivity,
        onRequestClose: onRequestCloseCommitPreviousActivity,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { isShouldShowCongratulation, isFirstLogin, showModal } = this.props
    if (isShouldShowCongratulation !== prevProps.isShouldShowCongratulation) {
      this.showCongratulations(this.props)
    }
    if (isFirstLogin) {
      showModal(<OnboardingFirstActivityModal />, { important: true, size: 'lg' })
    }
  }

  showCongratulations = props => {
    const { isShouldShowCongratulation, showModal, closeModal } = props
    if (isShouldShowCongratulation) {
      this.timer = setTimeout(() => showModal(UserCongratulationsPopup, { size: 'stretch', important: true }), 10000)
    } else {
      closeModal()
    }
  }

  componentWillUnmount() {
    this.timer && clearTimeout(this.timer)
    document.removeEventListener('visibilitychange', this.visible)
  }

  render() {
    const {
      isShouldShowProTrackRatingBlock,
      isStageIsSelection,
      isYesterdayUserActivity,
      isProTrackStopped,
    } = this.props
    const isShowProTrackSelectNew = isStageIsSelection && !isShouldShowProTrackRatingBlock
    return (
      <div className="content content--user-dashboard">
        <HasIrregularWorkWeek />
        <UserOutOfOfficeBlock />
        {isYesterdayUserActivity && !isProTrackStopped && <UserYesterdayActivity />}
        <UserProTrackStartBlock />
        {!isStageIsSelection && <UserActivityBlock />}
        {isShouldShowProTrackRatingBlock && <UserProtrackRating />}
        {isShowProTrackSelectNew && <UserProTrackSelectNew />}
        <UserBoard />
      </div>
    )
  }
}

export default Dashboard
